import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
const validate = ({ value }) => {
    return { isValid: !!value };
};
export const useValidateNotEmpty = () => {
    return (params) => {
        const state = validate(params);
        const errors = [];
        if (!state.isValid) {
            errors.push(_jsx(FormattedMessage, { id: "validate-not-empty.generic" }));
        }
        return { isValid: state.isValid, errors };
    };
};
